import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataMessageModel } from '@core/model/dataMessage.model';

@Component({
  selector: 'app-modal-confirmation',
  templateUrl: './modal-confirmation.component.html',
  styleUrls: ['./modal-confirmation.component.scss']
})
export class ModalConfirmationComponent implements OnInit {
  icon: any;
  labelTitile: string;
  textDescription: any;
  status: any;
  button = false;
  onAdd = new EventEmitter();
  onCancel = new EventEmitter();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DataMessageModel) {
  }
  ngOnInit() {
    this.icon = this.data.icon;
    this.labelTitile = this.data.labelTitile;
    this.status = this.data.status;
    this.textDescription = this.data.textDescription;
  }

  accept() {
    this.onAdd.emit(true);
  }

  cancel() {
    this.onCancel.emit(false);
  }
}
